/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: AlignmentButton.tsx
 * Project: mle-client-n
 * Committed last: 2022/1/25 @ 1258
 * ---
 * Description:
 */

import { Button, IconName, Intent, PopoverPosition } from '@blueprintjs/core';
import {
  HorizontalAlignment
}                                                    from '@revodigital/pamela/lib/configuration/Alignment';
import React                                         from 'react';
import {
  Tooltip2
}                                                    from '@blueprintjs/popover2';

interface Props {
  icon: IconName;
  currentAlignment: HorizontalAlignment;
  expectedAlignment: HorizontalAlignment;
  setter: (align: HorizontalAlignment) => void;
  tooltip?: string;
  tooltipPosition?: PopoverPosition;
  className?: string;
}

/**
 * Pulsante per gestire l'allineamento orizzontale di un testo
 * @param props
 * @constructor
 */
export const AlignmentButton = (props: Props) => {
  /**
   * Restituisce l'intent del pulsante per evidenziare quello che rappresenta l'allineamento
   * corretto.
   * @param value
   * @param expect
   */
  const getIntent = (value: HorizontalAlignment, expect: HorizontalAlignment): Intent =>
    (value === expect) ? Intent.PRIMARY : Intent.NONE;

  const content = <Button
    intent={ getIntent(props.currentAlignment, props.expectedAlignment) }
    small
    icon={ props.icon }
    onClick={ () => {
      props.setter(props.expectedAlignment);
    } }
  />;

  return (
    props.tooltip ?
    <Tooltip2 content={ props.tooltip } position={ props.tooltipPosition }>
      { content }
    </Tooltip2> : content
  );
};
